export type EnterpriseWorkspaceRole = 'executive' | 'hr' | 'manager' | 'partner';

const ROLE_KEY = 'tension_enterprise_workspace_role_v1';

export function getEnterpriseWorkspaceRole(): EnterpriseWorkspaceRole {
  if (typeof window === 'undefined') return 'executive';
  const raw = localStorage.getItem(ROLE_KEY);
  if (raw === 'executive' || raw === 'hr' || raw === 'manager' || raw === 'partner') return raw;
  return 'executive';
}

export function setEnterpriseWorkspaceRole(role: EnterpriseWorkspaceRole): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(ROLE_KEY, role);
}

